export const IOS_APP_STORE_BADGE_PREFIX = 'apple-app-store-badge';
export const ANDROID_APP_STORE_BADGE_PREFIX = 'google-play-badge';
